{
  "SEARCH": {
    "TABS": {
      "ALL": "Sve",
      "CONTACTS": "Kontakti",
      "CONVERSATIONS": "Razgovori",
      "MESSAGES": "Poruke"
    },
    "SECTION": {
      "CONTACTS": "Kontakti",
      "CONVERSATIONS": "Razgovori",
      "MESSAGES": "Poruke"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_MESSAGES": "Moje nedavno poslate poruke",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "od",
    "EMAIL": "e-pošta",
    "EMAIL_SUBJECT": "naslov"
  }
}
